export default __webpack_public_path__ + "static/media/1924.abf5d851.png";